import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import { monthsAbbreviated } from 'src/constants';

import './MonthSelect.css'
import { InputText } from 'src/framework/components/forms/inputs/InputText';

const newPtBRLocale: typeof ptBR = {
  ...ptBR,
  localize: {
    ...ptBR.localize as any,
    month(...args) {
      return monthsAbbreviated[args[0]]
    },
  }
}

interface MonthSelectProps extends ReactDatePickerProps {
  label: string
  wrapperClassName?: string
}

function MonthSelect({ label, selected, onChange, minDate, maxDate, wrapperClassName }: MonthSelectProps) {
  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      dateFormat="MMM/yyyy"
      showMonthYearPicker
      customInput={<InputText fullWidth label={label} InputProps={{ onKeyPress: (e: any) => { e.preventDefault(); return; } }} />}
      locale={newPtBRLocale}
      popperPlacement={'bottom'}
      showPopperArrow={false}
      popperClassName="month-popper-dimensionado"
      minDate={minDate}
      maxDate={maxDate}
      showFourColumnMonthYearPicker
      className='dimensionados-month-select-input'
      wrapperClassName={wrapperClassName}
    />
  )
}

export { MonthSelect };